// The builder's URL state: which run it follows and which tab shows. Pure; tested.
export type View = 'build' | 'report'

/** The Build | Report switch, in the URL so a reload keeps it. Pure; exported for tests. */
export function withView(current: URLSearchParams, view: View): URLSearchParams {
  const params = new URLSearchParams(current)
  if (view === 'report') params.set('view', 'report')
  else params.delete('view')
  return params
}

/** The run a started question opens, replacing whatever the page followed before. */
export function withRun(current: URLSearchParams, runId: string): URLSearchParams {
  const params = new URLSearchParams(current)
  params.set('runId', runId)
  params.delete('view')
  params.delete('templateId')
  return params
}

